var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaldives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56519 8.3479H26.4347V23.6523H5.56519V8.3479Z",
    fill: "#6DA544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5763 20.5217C16.079 20.5217 14.0545 18.4972 14.0545 15.9999C14.0545 13.5027 16.079 11.4782 18.5763 11.4782C19.3549 11.4782 20.0876 11.6751 20.7272 12.0217C19.7238 11.0404 18.3516 10.4347 16.8372 10.4347C13.7637 10.4347 11.272 12.9263 11.272 15.9999C11.272 19.0734 13.7637 21.5651 16.8372 21.5651C18.3516 21.5651 19.7238 20.9594 20.7272 19.9781C20.0876 20.3248 19.3549 20.5217 18.5763 20.5217Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaldives);
export default __webpack_public_path__ + "static/media/maldives.2bfd9b89.svg";
export { ForwardRef as ReactComponent };